import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { ContextApi } from '../context/ContextApi'


const styles = {
    footerStyle: {
    backgroundColor: "dodgerblue",
    width: "100%",
    height: "50px",
    bottom: 0,
    position: "fixed"
},
navStyle:{
    marginTop: "15px",
    marginLeft: "50px",
    marginRight: "auto",
    display: "flex",
    fontWeight: "300",
    fontSize: "12px",
    color: "white",
    alignItems: "center",
    justifyContent: "center"
},
firstStyle:{
    width: "20px",
    height: "2px",
    background: "white",
    margin: "3px 0px",
    borderRadius: "4px",
     },
secondStyle:{
    width: "30px",
    height: "2px",
    background: "white",
    margin: "3px 0px",
    borderRadius: "4px",
},
thirdStyle:{
    width: "30px",
    height: "2px",
    background: "white",
    margin: "3px 0px",
    borderRadius: "4px",

},
fouthStyle:{
    width: "15px",
    height: "2px",
    background: "white",
    margin: "0 5px",
    borderRadius: "4px",
},
rotateStyle:{
    transform: "rotate(90deg)",
    marginRight: "25px",
    marginTop: "auto",
    marginBottom: "auto",
},
favStyle:{
    fontWeight: "300",
    fontSize: "12px",
    color: "white",
    marginTop: "auto",
    marginBottom: "auto",
    marginRight: "25px",
    textDecoration: "none"
},
pStyle:{
    marginRight: "25px",
    marginTop: "auto",
    marginBottom: "auto",
    fontWeight: "300",
    fontSize: "12px",
}
}




class Footer extends Component{
    render(){
        const { footerStyle, pStyle, navStyle, firstStyle,secondStyle, thirdStyle, fouthStyle, rotateStyle, favStyle } = styles
        return(
            <footer style={footerStyle}>
                <div style={navStyle}>
                <ContextApi.Consumer>
                   {(context=>(
                    <p style={pStyle}> &copy; Jude {context.state.year}</p>
                   ))}
                </ContextApi.Consumer>
                   <NavLink to="/names">
                       <div style={rotateStyle}>
                       <div style={firstStyle}></div>
                       <div style={secondStyle}></div>
                       <div style={thirdStyle}></div>
                       <div style={fouthStyle}></div>
                       </div>
                    </NavLink>
                <NavLink style={favStyle} to="/hi"><i className="fas fa-star"> </i> Favourite Name </NavLink>
                <a style={favStyle} href="https://twitter.com/Jude_Li_Eric"><i className="fab fa-twitter"> </i>@Namesbymeaning</a>
                <NavLink style={favStyle} to="/names">Support</NavLink>
                </div>
            </footer>
        )
    }
};

export {Footer};


// WEBPACK FOOTER //
// ./src/components/UI/Footer.js